import { useSelector } from "react-redux";

/**
 * Returns the current organisation's terminology labels.
 * Falls back to the built-in defaults when no override is configured.
 *
 * Usage:
 *   const { customerLabel, siteLabel, customersLabel, sitesLabel } = useTerminology();
 *
 * `customerLabel`  → singular, e.g. "Client"
 * `customersLabel` → plural,   e.g. "Clients"
 * `siteLabel`      → singular, e.g. "Job"
 * `sitesLabel`     → plural,   e.g. "Jobs"
 */
const useTerminology = () => {
	const featureFlags = useSelector((state) => state.featureFlags);

	const customerLabel =
		featureFlags?.customerLabel && featureFlags.customerLabel.trim()
			? featureFlags.customerLabel.trim()
			: "Customer";

	const siteLabel =
		featureFlags?.siteLabel && featureFlags.siteLabel.trim()
			? featureFlags.siteLabel.trim()
			: "Site";

	return {
		customerLabel,
		customersLabel: customerLabel + "s",
		siteLabel,
		sitesLabel: siteLabel + "s",
	};
};

export { useTerminology };
